<template>
  <div class="item4base">
    <img class="logoico" src="../assets/images/logo.png" />
    <back></back>
    <div class="item4basebox">
      <div class="title">
        <div>典故篇</div>
      </div>
      <div class="content">
        <div class="leftcontent">
          <div class="listtitle">典故列表</div>
          <div class="leftlist">
            <a href="javascript:void(0);">
              <div class="activess item" @click="setnum(1)">
                <span>被封为药王</span>
              </div>
            </a>
            <a href="javascript:void(0);">
              <div class="item" @click="setnum(2)">
                <span>锯末治腹痛</span>
              </div>
            </a>
            <a href="javascript:void(0);">
              <div class="item" @click="setnum(3)">
                <span>用葱叶导尿</span>
              </div>
            </a>
            <a href="javascript:void(0);">
              <div class="item" @click="setnum(4)">
                <span>琥珀救产妇</span>
              </div>
            </a>
            <a href="javascript:void(0);">
              <div class="item" @click="setnum(5)">
                <span>寻找灵芝草</span>
              </div>
            </a>
            <a href="javascript:void(0);">
              <div class="item" @click="setnum(6)">
                <span>偶然识川芎</span>
              </div>
            </a>
            <a href="javascript:void(0);">
              <div class="item" @click="setnum(7)">
                <span>苦觅老鹳草</span>
              </div>
            </a>
            <a href="javascript:void(0);">
              <div class="item" @click="setnum(8)">
                <span>梓州治消渴</span>
              </div>
            </a>
            <a href="javascript:void(0);">
              <div class="item" @click="setnum(9)">
                <span>公布屠苏酒</span>
              </div>
            </a>
            <a href="javascript:void(0);">
              <div class="item" @click="setnum(10)">
                <span>命名“阿是穴”</span>
              </div>
            </a>
            <a href="javascript:void(0);">
              <div class="item" @click="setnum(11)">
                <span>彩绘明堂图</span>
              </div>
            </a>
            <a href="javascript:void(0);">
              <div class="item" @click="setnum(12)">
                <span>创制抓药柜</span>
              </div>
            </a>
          </div>
        </div>
        <div class="rightcontent">
          <img class="contentbag" src="../assets/images/work.png" />
          <pager ref="pager"></pager>
          <a class="syy" href="javascript:void(0);" @click="syy">上一篇</a>
          <a class="xyy" href="javascript:void(0);" @click="xyy">下一篇</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import back from "../components/backhome/back.vue";
import pager from "../components/pager/pager.vue";
import axios from "axios";
export default {
  components: {
    back,
    pager,
  },
  data() {
    return {
      pagenum: this.$route.query.id,
      token: this.$store.state.token,
      userid: this.$store.state.userid,
      videoisshow: false,
      videotitle: "",
      videolist: [],
    };
  },
  created() {},
  mounted() {
    let num = Number(this.pagenum) - 1;
    let allitem = document.getElementsByClassName("item");
    allitem[num].className = "activess item";
    this.setnum(this.pagenum);
  },
  methods: {
    syy() {
      if (this.pagenum > 1) {
        this.pagenum--;
        this.setnum(this.pagenum);
      }
    },
    xyy() {
      if (this.pagenum < 12) {
        this.pagenum++;
        this.setnum(this.pagenum);
      }
    },
    setnum(num) {
      this.pagenum = num;
      let allitem = document.getElementsByClassName("item");
      for (let i = 0; i < allitem.length; i++) {
        if (num - 1 == i) {
          allitem[i].className = "activess item";
        } else {
          allitem[i].className = "item";
        }
      }
      this.$refs.pager.setpagename(num);
    },
  },
};
</script>

<style scoped>
.item4base .syy,
.item4base .xyy {
  position: absolute;
  bottom: 0.6rem;
  z-index: 5;
  color: #a73a29;
  font-size: 1.1rem;
}
.item4base .syy {
  left: 6rem;
}
.item4base .xyy {
  right: 6rem;
}
.item4base {
  background: url(../assets/images/item5bag.jpg) no-repeat;
  background-size: 120% auto;
  background-position: left center;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  overflow: hidden;
}
.item4base .contentbag {
  width: 72.6rem;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
}
.item4base .item4basebox {
  position: absolute;
  z-index: 3;
  left: 1rem;
  top: 8rem;
  right: 1rem;
  bottom: 1rem;
  text-align: center;
}

.item4base .logoico {
  position: absolute;
  top: 3rem;
  left: 3rem;
  width: 18rem;
}

.item4base .title {
  text-align: center;
}

.item4base .title div {
  line-height: 6rem;
  width: calc(6rem * 6.39);
  height: 6rem;
  margin: 0px auto;
  background: url(../assets/images/itemtitlebag.png) no-repeat;
  background-size: 100%;
  font-family: "STXingkai";
  font-size: 3rem;
  color: #ffffff;
}

.item4base .content {
  width: 100rem;
  height: 50rem;
  margin: 0px auto;
  display: flex;
  margin-top: 2rem;
}

.item4base .leftcontent {
  width: 17rem;
  margin-right: 3rem;
  border: 2px solid #aa7a57;
  background: #ffffff;
}

.item4base .rightcontent {
  width: 80rem;
  position: relative;
}

.item4base .listtitle {
  background: linear-gradient(to bottom right, #aa7a57, #dbb48a);
  height: 4rem;
  margin-left: 1px;
  margin-right: 1px;
  line-height: 4rem;
  color: #ffffff;
  font-size: 1.3rem;
  font-weight: bold;
}

.item4base .leftlist {
  height: calc(51rem - 5px);
  margin-top: 1px;
  overflow-y: auto;
}
.item4base .leftlist::-webkit-scrollbar {
  width: 6px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

/*滚动条里面小方块*/
.item4base .leftlist::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #af805c;
}

/*滚动条里面轨道*/
.item4base .leftlist::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ede3db;
}
.item4base .leftlist div:last-child {
  border: none;
}
.item4base .leftlist div {
  width: 13rem;
  height: 3.5rem;
  line-height: 3.5rem;
  margin: 0px auto;
  font-size: 1.15rem;
  color: #b7886c;
  border-bottom: 1px dashed #aa7a57;
  position: relative;
}

.item4base .leftlist .activess {
  color: #5f3519;
  font-weight: bold;
}

.item4base .leftlist div span {
  display: inline-block;
}

.item4base .leftlist .activess span::before {
  content: "";
  position: absolute;
  width: 1rem;
  height: 1rem;
  background: url(../assets/images/jtright.png) no-repeat;
  background-size: 100%;
  left: 0.5rem;
  top: 0;
  bottom: 0;
  margin: auto;
}

.item4base .leftlist .activess span::after {
  content: "";
  position: absolute;
  width: 1rem;
  height: 1rem;
  background: url(../assets/images/jtleft.png) no-repeat;
  background-size: 100%;
  right: 0.5rem;
  top: 0;
  bottom: 0;
  margin: auto;
}

</style>
